import React, { useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import ImpressionSearch from './ImpressionSearch'
import { examUpdate } from '../../../../../../redux/actions/exam/examActions'
import { examFindingInfo, examFindingReset } from '../../../../../redux/actions/exam/examFindingActions'

function FindingImpression(props) {
  // Impression Associated with Finding
  const { selectedFinding, examId, impressions_attributes, wrapperClasses, handleFieldFocus, name, lastUsedImpressionIds } = props

  const examImpressionIds = impressions_attributes?.map(val => val.settings_impression_id) ?? []
  const existingVals = [...examImpressionIds, ...lastUsedImpressionIds]

  const [selectedIds, setSelectedIds] = useState(existingVals ?? [])
  const [uncheckedItems, setUncheckedItems] = useState([])
  const [findingDetails, setFindingDetails] = useState({})
  const dispatch = useDispatch()

  const handleAddToExam = async () => {
    const selectedIdsRaw = selectedIds.map(item => item.id || item);
    const impressionAttributes = handleAddRemoveArr(selectedIdsRaw)
    await dispatch(examUpdate({ id: examId, impressions_attributes: impressionAttributes, finding_details: findingDetails }, { include: '*' }))
    dispatch(examFindingReset())
    setFindingDetails({})
  }

  const handleAddRemoveArr = (selected_ids) => {
    const res = [...selected_ids, ...examImpressionIds]
    let combined = new Set(res);
    combined = Array.from(combined) // existing values
    // structured as per BE requirement
    let result = [...combined, ...uncheckedItems].map(item => {
      if (item) {
        if (item?.id) {
          // structure unchecked impression or delete case as per BE requirement
          return { ...item, _destroy: true }
        }
        return { settings_impression_id: item, findings_record: true }
      }
    })
    return result
  }

  const handleImpressions = (impression_ids) => {
    handleNonCommonVal(impression_ids)
    handleUncheckFlow(impression_ids)
    setSelectedIds(impression_ids)
  }

  const handleNonCommonVal = (impression_ids) => {
    // filter the checked item from mapped impression as per BE requirement
    let checkedItems = selectedFinding.impressions_attributes.filter(item => impression_ids.includes(item.id))
    checkedItems = checkedItems.map(item => item.id)
    setFindingDetails({ finding_id: selectedFinding.id, impression_ids: checkedItems })
    return checkedItems
  }

  const handleUncheckFlow = (impression_ids) => {
    const selectedIdsRaw = selectedIds.map(item => item.id || item);
    let uncheckVal = selectedIdsRaw.filter(item => !impression_ids.includes(item))
    const unCheckedValObj = impressions_attributes.find(item => item.settings_impression_id === uncheckVal[0])
    setUncheckedItems([...uncheckedItems, unCheckedValObj])
  }

  const handleImpressionMapped = () => {
    return selectedFinding.impressions_attributes
  }

  const handleAddFromSetting = () => {
    dispatch(examFindingInfo({ dropdownType: 'impression_settings' }))
  }

  const handleShowFinding = () => {
    let value = document.getElementsByName(name)
    handleFieldFocus(value[0]?.value ?? '')
  }

  return (
    <div className={`${wrapperClasses}`}>
      <h6 className='pb-4'>Mapped Diagnosis with Finding</h6>
      <div className='d-flex justify-content-between align-items-start'>
        <button type='button' className='btn btn-sm btn-outline-primary font-size-12 d-flex align-items-center' onClick={handleShowFinding}><i className="las la-angle-left mr-1"></i>Findings</button>
        <div className='d-flex flex-wrap align-items-center justify-content-end'>
          <button type='button' className='btn btn-sm btn-outline-primary font-size-12 mb-3' onClick={handleAddFromSetting}>
            <i className="las la-plus mr-1"></i>Add Dx
          </button>
          <button type='button' className={`btn btn-sm btn-primary font-size-12 ml-4 text-nowrap mb-4 ${selectedIds.length === 0 && 'disabled'}`} onClick={handleAddToExam} disabled={selectedIds.length === 0}>
            <i className="las la-plus mr-1"></i>Add To Exam
            <i className="las la-angle-right mr-2"></i>
          </button>
        </div>
      </div>
      <ImpressionSearch
        valueField='id'
        textField='name'
        wrapperClasses="mb-5"
        hideSearch={true}
        autoCompleteLoad={handleImpressionMapped}
        onSelectHook={impression_ids => handleImpressions(impression_ids)}
        defaultValues={existingVals}
      />
    </div>
  )
}
const mapStateToProps = state => {
  const { examFinding, exam: { exam } } = state

  return {
    selectedFinding: examFinding.selectedFinding,
    examId: exam.id,
    lastUsedImpressionIds: examFinding.selectedFinding?.last_used_impression_ids ?? [],
    impressions_attributes: exam.impressions_attributes
  }
}

export default connect(mapStateToProps)(FindingImpression)
